import { EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import React, { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';

import SearchHeader from '@/components/ui/SearchHeader/SearchHeader';

export const SearchFilters = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <div
      className="flex flex-col justify-between mb-6 md:mb-8 md:items-center md:flex-row gap-4"
      ref={ref}>
      <Heading variant={EHeadingStyleVariant.H4} className="font-normal" component="h2">
        <FormattedMessage defaultMessage="Select Your RV Rental" id="XHHmrH" />
      </Heading>

      <SearchHeader variant="minimal" />
    </div>
  );
});

SearchFilters.displayName = 'SearchFilters';
